import { send } from '../../../src/network';
import { type GetPromoResponse } from '../../../src/types/GetPromoResponse';

export { type GetPromoResponse };

type PromoPages = 'homepage' | '/limited-time/' | '/signup/';

export type Params = {
  page: PromoPages;
  promoCode?: string;
};

export async function getPromoData(params: Params) {
  const query = new URLSearchParams();
  const keys = Object.keys(params) as (keyof typeof params)[];
  keys.forEach((paramName) => {
    const value = params[paramName];
    if (value === undefined) {
      return;
    }
    query.append(paramName === 'promoCode' ? 'promo_code' : paramName, value);
  });
  return send<GetPromoResponse>({
    path: `/api/get_promo_data/`,
    method: 'GET',
    query,
  });
}
